export default __webpack_public_path__ + "static/media/zm.0f6225bc.svg";